import { IMGs } from '../assets/img'

export const getAvatarImage = (type?: String) => {
    if (!type) {
        return IMGs.defaultAvatar
    }

    let currentTier = type.toUpperCase()
    switch (currentTier) {
        case 'GRANDMASTER':
        case 'GM':
            return IMGs.grandMasterAvatar

        case 'MASTER':
            return IMGs.masterAvatar

        case 'DIAMOND':
            return IMGs.diamondAvatar

        case 'GOLD':
            return IMGs.goldAvatar

        case 'SILVER':
            return IMGs.silverAvatar

        case 'BRONZE':
            return IMGs.bronzeAvatar

        default:
            return IMGs.defaultAvatar
    }
}
